import { Controller } from '@hotwired/stimulus';
import './component.scss';

export default class extends Controller {
  static targets = ['card', 'activeLabel'];

  static values = {
    activeClass: String,
    labelVisibleClass: String,
    labelInvisibleClass: String,
  };

  connect() {}

  change(event) {
    /** @type {HTMLInputElement} */
    const target = event.target;

    if (!target.checked) {
      return;
    }

    // Highlight
    if (this.hasCardTarget) {
      this.cardTarget.classList.add(this.activeClassValue);
    }

    // Show label
    if (this.hasActiveLabelTarget) {
      this.activeLabelTarget.classList.add(this.labelVisibleClassValue);
      this.activeLabelTarget.classList.remove(this.labelInvisibleClassValue);
    }

    // Make other items aware that they're not selected anymore
    const radios = document.querySelectorAll(
      `input[type="radio"][name="${target.name}"]:not([value="${target.value}"])`
    );

    radios.forEach((elem) => elem.dispatchEvent(new CustomEvent('deselect')));
  }

  deselect() {
    // Remove highlight
    if (this.hasCardTarget) {
      this.cardTarget.classList.remove(this.activeClassValue);
    }

    // Hide label
    if (this.hasActiveLabelTarget) {
      this.activeLabelTarget.classList.add(this.labelInvisibleClassValue);
      this.activeLabelTarget.classList.remove(this.labelVisibleClassValue);
    }
  }
}
